import { render } from "./booking4.vue?vue&type=template&id=e7a98af8"
import script from "./booking4.vue?vue&type=script&lang=js"
export * from "./booking4.vue?vue&type=script&lang=js"
script.render = render

export default script